import { Box, TextField, List, ListItem, ListItemText, Checkbox, Typography, Paper, Alert } from '@mui/material'
import { useState, useEffect } from 'react'
import { apiIvcRoutes } from '../../routes'

const MaintenancePage = () => {
    const [machineList, setMachineList] = useState([])
    const [checklistItems, setChecklistItems] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedItem, setSelectedItem] = useState(null)
    const [isOffline, setIsOffline] = useState(!navigator.onLine)

    useEffect(() => {
        apiIvcRoutes.getMachines().then(data => {
            if (data.data) {
                setMachineList(data.data)
                const items = data.data.map((machine, index) => ({
                    id: machine._id || index,
                    name: machine.name || machine.nombre || `Máquina ${index + 1}`,
                    description: machine.description || machine.descripcion || 'Mantenimiento preventivo',
                    completed: false
                }))
                setChecklistItems(items.length > 0 ? items : [
                    { id: 1, name: 'Revisión de motor', description: 'Verificar funcionamiento del motor principal', completed: false },
                    { id: 2, name: 'Cambio de filtros', description: 'Reemplazar filtros de aire y aceite', completed: false },
                    { id: 3, name: 'Inspección hidráulica', description: 'Revisar niveles y mangueras hidráulicas', completed: false }
                ])
            }
        }).catch(() => {
            setChecklistItems([
                { id: 1, name: 'Revisión de motor', description: 'Verificar funcionamiento del motor principal', completed: false },
                { id: 2, name: 'Cambio de filtros', description: 'Reemplazar filtros de aire y aceite', completed: false },
                { id: 3, name: 'Inspección hidráulica', description: 'Revisar niveles y mangueras hidráulicas', completed: false }
            ])
        })
    }, [])

    useEffect(() => {
        const handleOnline = () => setIsOffline(false)
        const handleOffline = () => setIsOffline(true)
        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)
        return () => {
            window.removeEventListener('online', handleOnline)
            window.removeEventListener('offline', handleOffline)
        }
    }, [])

    const filteredItems = checklistItems.filter(item =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.description.toLowerCase().includes(searchQuery.toLowerCase())
    )

    const handleToggleComplete = (itemId) => {
        setChecklistItems(prev =>
            prev.map(item =>
                item.id === itemId ? { ...item, completed: !item.completed } : item
            )
        )
    }

    return (
        <Box sx={{ p: 2 }}>
            {isOffline && (
                <Alert data-testid="offline-indicator" severity="warning" sx={{ mb: 2 }}>
                    Sin conexión — Los cambios se guardarán localmente
                </Alert>
            )}
            <h1>Mantenimiento</h1>
            <TextField
                data-testid="search-input"
                fullWidth
                placeholder="Buscar elementos..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ mb: 2 }}
            />
            <List>
                {filteredItems.map((item) => (
                    <ListItem
                        key={item.id}
                        data-testid="checklist-item"
                        button
                        onClick={() => setSelectedItem(item)}
                        secondaryAction={
                            <Checkbox
                                data-testid="checklist-checkbox"
                                checked={item.completed}
                                onChange={(e) => {
                                    e.stopPropagation()
                                    handleToggleComplete(item.id)
                                }}
                            />
                        }
                    >
                        <ListItemText
                            primary={item.name}
                            secondary={item.description}
                        />
                    </ListItem>
                ))}
            </List>
            {selectedItem && (
                <Paper data-testid="item-details" sx={{ p: 2, mt: 2 }}>
                    <Typography variant="h6">{selectedItem.name}</Typography>
                    <Typography variant="body1">{selectedItem.description}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Estado: {selectedItem.completed ? 'Completado' : 'Pendiente'}
                    </Typography>
                </Paper>
            )}
        </Box>
    )
}

export default MaintenancePage
